export default __webpack_public_path__ + "static/PEPEZEUSLIGHT-50701136469b98631409011a4f603003.jpg";